import { ProductJsonLd } from 'next-seo';
import { useContext } from 'use-context-selector';
import { ProductContext } from 'components/productContext/ProductProvider';
import type { StoreMediaImage } from '../productContext/types/storeMedia';

const ProductStructuredData = () => {
  const product = useContext(ProductContext);

  if (product === undefined)
    throw new Error(
      'ProductStructuredData must be used within a ProductContext'
    );

  return (
    <ProductJsonLd
      productName={product.title}
      images={(product.media as StoreMediaImage[]).map(
        (media) => media?.image?.url
      )}
      offers={[
        {
          priceCurrency: product?.price?.currencyCode,
          price: product?.price?.amount,
          availability: `https://schema.org/${
            product?.selectedVariant?.availableForSale
              ? 'InStock'
              : 'OutOfStock'
          }`,
        },
      ]}
      description={product.description}
    />
  );
};

export default ProductStructuredData;
